/* string-transformation.ts */

/* Lodash */
import { camelCase, isArray, isObject } from "lodash";

export const capitalizeFirstLetter = (
  str: string
): string => {
  return (
    str?.charAt(0).toUpperCase() +
    str?.slice(1).toLowerCase()
  );
};

export const capitalizeCamelCaseFirstLetter = (
  str: string
) => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(" ")
    .map((word) => capitalizeFirstLetter(word))
    .join(" ");
};

export const toSnakeCase = <T>(object: T): T => {
  if (Array.isArray(object)) {
    return object.map((item) =>
      toSnakeCase(item)
    ) as unknown as T;
  } else if (object && typeof object === "object") {
    return Object.entries(object).reduce(
      (acc, [key, value]) => {
        const transformedKey = key
          .replace(/([A-Z])/g, "_$1")
          .toLowerCase();
        acc[transformedKey] = toSnakeCase(value);
        return acc;
      },
      {} as any
    );
  }
  return object;
};

export const toCamelCase = <T>(object: T): T => {
  if (isArray(object)) {
    return object.map((item) => toCamelCase(item)) as T;
  } else if (isObject(object)) {
    return Object.fromEntries(
      Object.entries(object).map(([key, value]) => [
        camelCase(key),
        toCamelCase(value),
      ])
    ) as T;
  }
  return object;
};

/**
 * Transform a string in camelCase format to uppercase.
 */
export const camelCaseToUppercase = (key: string) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};

// Remove suffix like '(TL1)' or '(milligram)' from labels
export const stripLabelSuffix = (label: string): string => {
  return label.replace(/\s*\(.*?\)/g, "").trim();
};
